import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store";
import { Provider as ReduxProvider } from "react-redux";
import SuspenseContent from "./components/SuspenseContent";



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback={<SuspenseContent/>}>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App  />
      </PersistGate>
    </ReduxProvider>
  </Suspense>
);


reportWebVitals();
